module.exports = __webpack_public_path__ + "static/communal-park-text-a927bf9f7a0cc6797137987401405be7.png";